import PropTypes from 'prop-types'
import React from 'react'
import { useQuery } from '@apollo/client'
import { GET_CATEGORIES } from 'Queries'
import { CATEGORY_DEFAULT_LIMIT } from 'Constants'
import Collapse from '../Collapse'
import Title from '../Title'
import { Spinner, Icon, ErrorView, Link } from 'Blocks'
import config from 'Config'

const Item = ({ name, to }) => (
  <li>
    <Link to={to}>{name}</Link>
  </li>
)

Item.propTypes = {
  name: PropTypes.any,
  to: PropTypes.any
}

const TopCategories = ({ className }) => {
  const customToggleIcon = config.topCategoriesIcon ? (
    <Icon
      className={config.topCategoriesIcon}
      name={config.topCategoriesIcon}
    />
  ) : null

  const variables = {
    arguments: {
      categoryUuid: process.env.ANT_BROWSE_ID
    },
    pagination: {
      size: CATEGORY_DEFAULT_LIMIT,
      page: 1
    }
  }

  const { loading, error, data } = useQuery(GET_CATEGORIES, { variables })

  if (!config.filters.topLevelCategories) return null
  if (loading) return <Spinner />
  if (error) return <ErrorView message={error.message} error={error} />
  return (
    <Collapse
      isHidden={false}
      customToggleIcon={customToggleIcon}
      className={`collapsable ${className}`}
      showToggleIcon
      header={<Title>Top Categories</Title>}
    >
      <ul>
        {data.categories.categories.map((item, key) => (
          <Item
            key={`item-cat-${key}`}
            {...{ key, ...item }}
            to={`${config.shopPath}/products/${item.uuid}/${item.slug}`}
          />
        ))}
      </ul>
    </Collapse>
  )
}

TopCategories.propTypes = {
  className: PropTypes.any
}

export default TopCategories
